// COMPANY EVENTS (punch list S25, S26; Jeremy, 1 Nov 2026; docs/AGREED_NEXT.md item 4).
//
// HR adds them on the HR tab. Two kinds:
//   - BLACKOUT: no PTO, no no-travel day and no field work may be booked on any of its days. A
//     GATE (gates.ts, after working days and before already committed) and checkDeployment().
//     A request that only partly overlaps is refused WHOLE, naming the event: silently dropping
//     the blacked-out days would turn it into a different request from the one asked for.
//     Everyone, HR and acting-as included; HR removes the event if an exception is needed.
//   - INFO: shown on the calendar, changes nothing, and must never acquire a gate.
// Bookings already inside a new blackout are left as they are; one still PENDING cannot be
// approved (same message, requests/service.ts decideRequest), only denied.
import { mdyRange } from './dates.js';
export const COMPANY_EVENT_KINDS = ['BLACKOUT', 'INFO'];
/** What a person reads for each kind, on the HR tab. Jeremy's words, exactly (1 Nov 2026). */
export const COMPANY_EVENT_KIND_LABEL = {
    BLACKOUT: 'Blackout - no PTO, no-travel days or field work',
    INFO: 'Information only',
};
/**
 * The first BLACKOUT (by first day, then name) touching any day of start..end, or null. Only
 * blackouts: an information-only event never stops anything.
 */
export function blackoutOver(start, end, events) {
    const hits = events
        .filter(e => e.kind === 'BLACKOUT' && e.firstDay <= end && e.lastDay >= start)
        .sort((a, b) => a.firstDay.localeCompare(b.firstDay) || a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
    return hits[0] ?? null;
}
/**
 * The refusal, in Jeremy's words (1 Nov 2026). The dates as every gate message names a range
 * (mdyRange: "11/23/2026", "11/23/2026 – 11/25/2026"), so a one-day event shows one date.
 */
export function blackoutMessage(e) {
    return `${e.name} (${mdyRange(e.firstDay, e.lastDay)}) is a company blackout: no PTO, no-travel days or field work can be booked then.`;
}
//# sourceMappingURL=company-events.js.map